import "./jquery";
import "picturefill";

import "bootstrap-sass/assets/javascripts/bootstrap/scrollspy.js";
import "bootstrap-sass/assets/javascripts/bootstrap/dropdown.js";
import "bootstrap-sass/assets/javascripts/bootstrap/collapse.js";
import "bootstrap-sass/assets/javascripts/bootstrap/transition.js";
import "bootstrap-sass/assets/javascripts/bootstrap/affix.js";

import './legacy';
import './header';
import './selectize';



// WEBPACK FOOTER //
// ./assets/scripts/main.js